import { DEFAULT_STATE } from '../constants'
import { searchPageStore } from '../index'

export const setSimulationReady = (simulationReady) => {
  searchPageStore.setState({ simulationReady })
}

export const clearSimulationReady = () => {
  searchPageStore.setState({ simulationReady: DEFAULT_STATE.simulationReady })
}
